import type { PropertyImage } from '@/domain/properties';
import type { FC } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

interface Props {
  images: PropertyImage[] | undefined;
}

const PropertyImagesCarousel: FC<Props> = ({ images }) => {
  return (
    <section className="bg-black">
      <div className="max-w-7xl mx-auto">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop
          className="h-[400px] md:h-[600px]"
        >
          {images?.map((image) => (
            <SwiperSlide key={`property-image-${image.id}`}>
              <img src={image.url} className="w-full h-full object-cover" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default PropertyImagesCarousel;
